var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "floor" }, [
    _c(
      "div",
      { staticClass: "floor_area" },
      [
        _c("div", { staticClass: "zoomIcon", on: { click: _vm.handleZoom } }),
        _vm._v(" "),
        _c("floorMap", {
          ref: "childrenFloorMap",
          attrs: { height: _vm.floorHeight, isStatus: _vm.isStatus }
        }),
        _vm._v(" "),
        _vm.alarmList.length > 0
          ? _c("div", { staticClass: "mask" }, [
              _c(
                "div",
                { staticClass: "alarm_box" },
                [
                  _c("alarmBox", {
                    attrs: { alarmContent: _vm.alarmList },
                    on: { deal: _vm.is_receive, showDeatil: _vm.alarmDetail }
                  })
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _c("dialogItem", {
          attrs: { "show-dialog": _vm.showDialog, dialogData: _vm.detail },
          on: { closeDialog: _vm.closeDialog, close_alarm: _vm.clear_alarm }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "audio",
        {
          staticStyle: { display: "none" },
          attrs: { id: "audio2", preload: "auto" }
        },
        [
          _c("source", {
            attrs: {
              src:
                "https://gas95.oss-cn-beijing.aliyuncs.com/monitor/static/mp3/baojing.mp3",
              type: "audio/mpeg"
            }
          })
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d047e242", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d047e242","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/main_content/floor_distribution/floor_main.vue
// module id = null
// module chunks = 